exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".analyWrap{justify-content:space-around;padding:16px 16px 16px 0}.analyWrap,.analyWrapChild{border-right:1px solid #e8eef0}.analyWrapChild{cursor:pointer}.analyWrapFlex{display:flex;align-items:center;background:#fff;border-radius:4px}.analyWrapFlex .imgMarkWrap{width:68px;height:68px;text-align:center;display:flex;align-content:center;align-items:center;justify-content:center;margin:0 16px}.analyWrapFlex .title{color:#616f6f;font-size:16px}.analyWrapFlex .num{line-height:40px;font-weight:700;font-size:30px;height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75528b3d","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--5!./src/component/statistical-analysis/index.vue
// module id = 4
// module chunks = 0